import { css } from 'styled-components';
import Functions from './Functions';
import { BreakpointKey, Fonts } from './Variables';

// export const responsiveTextSize = (
// 	small: keyof (typeof Fonts)['sizes'],
// 	large: keyof (typeof Fonts)['sizes'],
// 	breakpoint: string = Breakpoints.mobile
// ) => {
// 	return css`
// 		font-size: ${Fonts['sizes'][small]}px;
// 		${Functions.breakpoint(breakpoint)} {
// 			font-size: ${Fonts['sizes'][large]}px;
// 		}
// 	`;
// };

type FontSize = keyof (typeof Fonts)['sizes'];
type FontFamily = keyof (typeof Fonts)['families'];
type FontWeight = keyof (typeof Fonts)['weights'];

export class TextStyle {
	public static weight(weight: FontWeight) {
		return css`
			font-weight: ${Fonts['weights'][weight]};
		`;
	}

	public static family(family: FontFamily) {
		return css`
			font-family: ${Fonts['families'][family]};
		`;
	}

	public static size(size: FontSize, large?: FontSize, breakpoint?: BreakpointKey) {
		if (!large) {
			return css`
				font-size: ${Fonts['sizes'][size]}px;
			`;
		}
		return css`
			font-size: ${Fonts['sizes'][size]}px;

			@media ${Functions.media(breakpoint ?? 'mobile')} {
				font-size: ${Fonts['sizes'][large]}px;
			}
		`;
	}
}
